export const SECTION_IDS = {
  COMPANY_PROFILE: "company-profile",
  FACILITIES_ENERGY: "facilities-energy",
  VEHICLES_FUEL: "vehicles-fuel",
  TRAVEL_REMOTE: "travel-remote-work",
  PURCHASES: "purchases-suppliers-products",
  TOTALS_REVIEW: "totals-review"
};

export const SURVEY_SECTIONS = [
  { id: SECTION_IDS.COMPANY_PROFILE, label: "Company Profile" },
  { id: SECTION_IDS.FACILITIES_ENERGY, label: "Facilities & Energy" },
  { id: SECTION_IDS.VEHICLES_FUEL, label: "Vehicles & Fuel" },
  { id: SECTION_IDS.TRAVEL_REMOTE, label: "Travel & Remote Work" },
  { id: SECTION_IDS.PURCHASES, label: "Purchases, Suppliers & Products" },
  { id: SECTION_IDS.TOTALS_REVIEW, label: "Totals & Review" }
];

const TRANSACTION_CATEGORY_SECTION = {
  "Business Travel": SECTION_IDS.TRAVEL_REMOTE,
  "Transportation/Freight": SECTION_IDS.PURCHASES,
  "Capital Goods": SECTION_IDS.PURCHASES,
  Services: SECTION_IDS.PURCHASES
};

export const sectionForTransactionCategory = (title) =>
  TRANSACTION_CATEGORY_SECTION[title] || SECTION_IDS.PURCHASES;

export const findSectionIndex = (sectionId) =>
  SURVEY_SECTIONS.findIndex(({ id }) => id === sectionId);
